import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_AD_UNIT_PRODUCT_ENABLED: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateAdUnitProductEnabled($input: UpdateAdUnitProductEnabledInput!) {
    updateAdUnitProductEnabled(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
